export const getHeaderLang = (lang) => {
    let Language = "en"
    if (lang === 'zh_CN') Language = "zh"
    if (lang === 'en_US') Language = "en"
    if (lang === 'ko_US') Language = "ko"
    if (lang === 'ja_US') Language = "ja"
    if (lang === 'hi_US') Language = "hi"
    if (lang === 'es_US') Language = "es"
    if (lang === 'pt_US') Language = "pt"
    if (lang === 'fr_US') Language = "fr"
    if (lang === 'de_US') Language = "de"
    if (lang === 'sv_US') Language = "sv"
    if (lang === 'pl_US') Language = "pl"
    return Language
}
// 专门处理你的扫码数据格式
export function isScanUrlSameAsCurrent(scanResult) {
    try {
        // 判断扫码结果中的URL是否包含 /sr? 路由
        // 因为扫码地址和当前页面地址可能不同，只要包含 /sr? 就认为是有效的
        if (!scanResult || typeof scanResult !== 'string') {
            return false
        }
        // 检查是否包含 /sr? 路由
        return scanResult.includes('/sr?')
    } catch {
        return false
    }
}